module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesCool.5d976cd.jpg";